module.exports = __webpack_public_path__ + "static/img/zdhf08_bg.484fe50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf08_bg.png
// module id = 125
// module chunks = 0